import {
    Grid, Card, CardContent, CardHeader, List, ListItem, ListItemAvatar, Avatar, ListItemText, Typography,
    Breadcrumbs,
    Link,
    Snackbar,
    ListItemIcon,
    ListItemButton
} from '@mui/material'
import HomeTwoToneIcon from '@mui/icons-material/HomeTwoTone';
import AddHomeWorkTwoToneIcon from '@mui/icons-material/AddHomeWorkTwoTone';
import Fab from '@mui/material/Fab';
import AddIcon from '@mui/icons-material/Add';
import CloseIcon from '@mui/icons-material/Close';
import { useState } from 'react';
import CheckCircleTwoToneIcon from '@mui/icons-material/CheckCircleTwoTone';
import AutoStoriesTwoToneIcon from '@mui/icons-material/AutoStoriesTwoTone';

export default function Manuales() {

    return (
        <>
            <Grid container direction='row' justifyContent='center' style={{ marginTop: 50 }} gap={3}>
                <Grid item md={12} lg={4}>
                    <Card style={{ height: '100%', width: '100%' }}>
                        <CardHeader title='Manuales Perfil Asistente'></CardHeader>
                        <CardContent>                            
                            <Grid container direction='row'>
                                <Grid xl={12} sm={12}>
                                    <List
                                        sx={{ width: '100%', bgcolor: 'background.paper' }}
                                        aria-label="contacts"
                                    >
                                        <ListItem disablePadding onClick={() => window.open("/manuales/asistente/CursoFase2GestionPresupuestalCCV-Asistente-CatalogoPartidas_2025-06-18.pdf")}>
                                            <ListItemButton>
                                                <ListItemIcon>
                                                    <AutoStoriesTwoToneIcon color='secondary' />
                                                </ListItemIcon>
                                                <ListItemText primary="Catálogo de partidas" />
                                            </ListItemButton>
                                        </ListItem>
                                        <ListItem disablePadding onClick={() => window.open('/manuales/asistente/CursoFase2GestionPresupuestalCCV-Asistente-ConfiguracionAvisos_2025-06-18.pdf')}>
                                            <ListItemButton>
                                                <ListItemIcon>
                                                    <AutoStoriesTwoToneIcon color='secondary' />
                                                </ListItemIcon>
                                                <ListItemText primary="Gestión de avisos" />
                                            </ListItemButton>
                                        </ListItem>
                                        <ListItem disablePadding onClick={() => window.open('/manuales/asistente/CursoFase2GestionPresupuestalCCV-Asistente-ConfiguracionMontos_2025-06-18.pdf')}>
                                            <ListItemButton>
                                                <ListItemIcon>
                                                    <AutoStoriesTwoToneIcon color='secondary' />
                                                </ListItemIcon>
                                                <ListItemText primary="Configuración de montos" />
                                            </ListItemButton>
                                        </ListItem>
                                        <ListItem disablePadding onClick={() => window.open('/manuales/asistente/CursoFase2GestionPresupuestalCCV-Asistente-SeguimientoSolicitudes_2025-06-18.pdf')}>
                                            <ListItemButton>
                                                <ListItemIcon>
                                                    <AutoStoriesTwoToneIcon color='secondary' />
                                                </ListItemIcon>
                                                <ListItemText primary="Seguimiento de solicitudes" />
                                            </ListItemButton>
                                        </ListItem>
                                        <ListItem disablePadding onClick={() => window.open('/images/MejorasNotificacionesPagoContratosAsistente-V2.png')}>
                                            <ListItemButton>
                                                <ListItemIcon>
                                                    <AutoStoriesTwoToneIcon color='secondary' />
                                                </ListItemIcon>
                                                <ListItemText primary="Pagos por contrato" />
                                            </ListItemButton>
                                        </ListItem>
                                    </List>                                  

                                </Grid>
                            </Grid>
                        </CardContent>
                    </Card>
                </Grid>
                <Grid item md={12} lg={4}>
                    <Card style={{ height: '100%', width: '100%' }}>
                        <CardHeader title='Manuales Perfil Jefatura de Departamento / Dirección de División / Coordinación'></CardHeader>
                        <CardContent>                            
                            <Grid container direction='row'>
                                <Grid xl={12} sm={12}>
                                    <List
                                        sx={{ width: '100%', bgcolor: 'background.paper' }}
                                        aria-label="contacts"
                                    >
                                        
                                        <ListItem disablePadding onClick={() => window.open('/manuales/titularArea/CursoFase2GestionPresupuestalCCV-JefeDepto_DirectorDivision-ConfiguracionAvisos_2025_06_17.pdf')}>
                                            <ListItemButton>
                                                <ListItemIcon>
                                                    <AutoStoriesTwoToneIcon color='secondary' />
                                                </ListItemIcon>
                                                <ListItemText primary="Gestión de avisos" />
                                            </ListItemButton>
                                        </ListItem>
                                        <ListItem disablePadding onClick={() => window.open('/manuales/titularArea/CursoFase1GestionPresupuestalCCV_JefeDpto_2025-06-09.pdf')}>
                                            <ListItemButton>
                                                <ListItemIcon>
                                                    <AutoStoriesTwoToneIcon color='secondary' />
                                                </ListItemIcon>
                                                <ListItemText primary="Registro de planeación presupuestal" />
                                            </ListItemButton>
                                        </ListItem>
                                        <ListItem disablePadding onClick={() => window.open('/manuales/titularArea/CursoFase2GestionPresupuestalCCV-JefeDpto_DirectorDivision-SolicitudServicio_2025-06-13.pdf')}>
                                            <ListItemButton>
                                                <ListItemIcon>
                                                    <AutoStoriesTwoToneIcon color='secondary' />
                                                </ListItemIcon>
                                                <ListItemText primary="Registro de solicitud de servicio" />
                                            </ListItemButton>
                                        </ListItem>
                                        <ListItem disablePadding onClick={() => window.open('/manuales/titularArea/CursoFase2GestionPresupuestalCCV-JefeDpto_DirectorDivision-SeguimientoSolicitudes_2025_06_09.pdf')}>
                                            <ListItemButton>
                                                <ListItemIcon>
                                                    <AutoStoriesTwoToneIcon color='secondary' />
                                                </ListItemIcon>
                                                <ListItemText primary="Seguimiento de solicitudes de servicio" />
                                            </ListItemButton>
                                        </ListItem>
                                    </List>
                                </Grid>
                            </Grid>
                        </CardContent>
                    </Card>
                </Grid>
                <Grid item md={12} lg={4}>
                    <Card style={{ height: '100%', width: '100%' }}>
                        <CardHeader title='Manuales Perfil Jefe de Área / Responsable de proyecto(s)'></CardHeader>
                        <CardContent>                            
                            <Grid container direction='row'>
                                <Grid xl={12} sm={12}>
                                    <List
                                        sx={{ width: '100%', bgcolor: 'background.paper' }}
                                        aria-label="contacts"
                                    >
                                        <ListItem disablePadding onClick={() => window.open("/manuales/jefeArea/CursoFase2GestionPresupuestalCCV-JefeArea-SolicitudServicio_2025-06-16.pdf")}>
                                            <ListItemButton>
                                                <ListItemIcon>
                                                    <AutoStoriesTwoToneIcon color='secondary' />
                                                </ListItemIcon>
                                                <ListItemText primary="Registro de solicitud de servicio" />
                                            </ListItemButton>
                                        </ListItem>
                                        <ListItem disablePadding onClick={() => window.open('/manuales/jefeArea/CursoFase2GestionPresupuestalCCV-JefeArea-SeguimientoSolicitudes_2025-06-17.pdf')}>
                                            <ListItemButton>
                                                <ListItemIcon>
                                                    <AutoStoriesTwoToneIcon color='secondary' />
                                                </ListItemIcon>
                                                <ListItemText primary="Seguimiento de solicitudes de servicio" />
                                            </ListItemButton>
                                        </ListItem>                                        
                                    </List>
                                </Grid>
                            </Grid>
                        </CardContent>
                    </Card>
                </Grid>
                <Grid item md={12} lg={4}>
                    <Card style={{ height: '100%', width: '100%' }}>
                        <CardHeader title='Manuales Otros'></CardHeader>
                        <CardContent>                            
                            <Grid container direction='row'>
                                <Grid xl={12} sm={12}>
                                    <List
                                        sx={{ width: '100%', bgcolor: 'background.paper' }}
                                        aria-label="contacts"
                                    >
                                        <ListItem disablePadding  onClick={() => window.open("/images/MejorasNotificacionesPagoContratosUsuario.png")}>
                                            <ListItemButton>
                                                <ListItemIcon>
                                                    <AutoStoriesTwoToneIcon color='secondary' />
                                                </ListItemIcon>
                                                <ListItemText primary="Pagos por contrato" />
                                            </ListItemButton>
                                        </ListItem>
                                        <ListItem disablePadding onClick={() => window.open('/images/AGPclavesSIIUAM.pdf')}>
                                            <ListItemButton>
                                                <ListItemIcon>
                                                    <AutoStoriesTwoToneIcon color='secondary' />
                                                </ListItemIcon>
                                                <ListItemText primary="Claves SIIUAM" />
                                            </ListItemButton>
                                        </ListItem>
                                        <ListItem disablePadding onClick={() => window.open('/images/subirDocumentosGenerales.pdf')}>
                                            <ListItemButton>
                                                <ListItemIcon>
                                                    <AutoStoriesTwoToneIcon color='secondary' />
                                                </ListItemIcon>
                                                <ListItemText primary="Subir documentos complementarios (no obligatorios) a una solicitud" />
                                            </ListItemButton>
                                        </ListItem>
                                        <ListItem disablePadding onClick={() => window.open('/images/AvancePresupuestal.pdf')}>
                                            <ListItemButton>
                                                <ListItemIcon>
                                                    <AutoStoriesTwoToneIcon color='secondary' />
                                                </ListItemIcon>
                                                <ListItemText primary="Descargar avance presupuestal" />
                                            </ListItemButton>
                                        </ListItem>
                                    </List>

                                </Grid>
                            </Grid>
                        </CardContent>
                    </Card>
                </Grid>
            </Grid>
        </>
    )
}